import './App.css';
import SignUp from './component/SignUp';
import { Box } from '@mui/material';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import NearMeIcon from '@mui/icons-material/NearMe';
import MarkEmailUnreadIcon from '@mui/icons-material/MarkEmailUnread';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import { useTranslation } from 'react-i18next';
import i18n from './i18n';
import { Button, Menu, MenuItem } from '@mui/material';
import { useEffect, useState } from 'react';

function App() {
  
  // start the translation way
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);

  // make the open true when i click on button to open the menue
  const open = Boolean(anchorEl);

  // get the button and make the state is the button
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    const newLang = i18n.language === "ar" ? "en" : "ar";
    i18n.changeLanguage(newLang);
    window.location.reload()
  };
  // end the translation way
  // set default language only once
  useEffect(() => {
  const savedLang = localStorage.getItem("i18nextLng");
  const alreadyReloaded = localStorage.getItem("reloaded");
  const lang = savedLang.startsWith("en") ? "ar" : savedLang;
  if(!alreadyReloaded) {
    localStorage.setItem("reloaded", "true");
    window.location.reload();
    i18n.changeLanguage(lang);
  }
  }, []);
  
  return (
    <div className="App min-h-screen flex flex-col">
      <div className="bg-[#0077B6] sm:px-20 max-sm:px-10 py-3 text-white flex gap-2">
        <a
          href="https://www.facebook.com/AdentalisDentalAcademy/"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:underline"
        >
          <FacebookIcon />
        </a>
        <a
          href="https://www.instagram.com/adentalisacademy/"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:underline"
        >
          <InstagramIcon />
        </a>
      </div>
      <header className="text-white flex justify-between items-center py-3 sm:px-20 max-sm:px-3 gap-2 sm:gap-0 shadow-lg pb-5 max-sm:pb-0">
        <div className='flex items-center gap-5'>
          <div>
            <Button
              onClick={handleClick}
              style={{backgroundColor: "#006CA5",color: "white", fontWeight: "bold"}}
            >
              {i18n.language === 'ar' ? 'English' : 'العربية'}
            </Button>
          </div>
          <div className="text-[#006CA5] max-sm:hidden text-center sm:text-left font-bold">
            <a
              href="https://adentalis.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:underline"
            >
              {t("visit_the_website")}
            </a>
          </div>
        </div>
        <div>
          <Box
            component="img"
            src="/adentalis_logo.png"
            alt="Logo 3"
              className='logo3 w-[150px]'
          />
        </div>
      </header>
      <main className="flex-1">
        <SignUp />
      </main>
      <footer dir={i18n.language === "en" ? "ltr" : "rtl"} className='text-white'>
        <div className='bg-[#0077B6]'>
          <div className='sm:px-20 py-2 max-sm:px-10 w-full flex justify-between max-md:flex-col max-md:items-center'>
            <div className={`flex flex-col w-[30%] max-md:w-full`}>
              <h2 className='text-[24px] font-bold mb-5'>{t("who_are_we")}</h2>
              <p>{t("description")}</p>
              <div className="py-3 text-white flex gap-2">
                <a
                  href="https://www.facebook.com/AdentalisDentalAcademy/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:underline"
                >
                  <FacebookIcon />
                </a>
                <a
                  href="https://www.instagram.com/adentalisacademy/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:underline"
                >
                  <InstagramIcon />
                </a>
              </div>
            </div>
            <div className="max-md:w-full max-md:mt-5">
              <h2 className='text-[24px] font-bold mb-5'>{t("contact_us")}</h2>
              <div className='flex flex-col'>
                <div className='flex items-center gap-2 mb-3'>
                  <NearMeIcon/>
                  <p>{t("location")}</p>
                </div>
                <div className='mb-3'>
                  <a target="_blank" href='mailto:info@adentalis.com' className='flex items-center gap-2 '>
                    <MarkEmailUnreadIcon/>
                    <p>info@adentalis.com</p>
                  </a>
                </div>
                <div className='flex items-center gap-2 mb-3'>
                  <a target="_blank" href='tel:+963944275742' className='flex items-center gap-2'>
                    <LocalPhoneIcon/>
                    <p>{i18n.language === "en" ? "+963-944275742" : "963-944275742+"}</p>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='bg-[#00B8A9] max-sm:text-[12px] text-center p-1 font-bold'>
          <a href='https://aigate.me/' target='_blanck'>
            <p>{t("copyright")} {new Date().getFullYear()} | {t("developed")}</p>
          </a>
        </div>
      </footer>
    </div>
  );
}

export default App;
